import { IBaseKernel } from "@gratico/sdk";

export function setupLocalChannel(kernel: IBaseKernel) {
  const bc = new BroadcastChannel("project");
  return bc;
}
